import React, { useEffect, useState } from 'react';
import Additional from './components/Additional';
import Contact from './components/Contact';
import Header from './components/Header';
import Leisure from './components/Leisure/Leisure';
import Loading from './components/Loading';
import Navigation from './components/Navigation';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Stack from './components/Stack';
import Work from './components/Work';



function App() {
	const [isLoading, setisLoading] = useState(true);

	useEffect(() => {
		setTimeout(() => {
			setisLoading(false);
		}, 2500);
	});

	return (
		<>
			{isLoading ? (
				<Loading />
			) : (
				<>
					<Navigation />
					<Header />
					<Work />
					<Additional />
					<Stack />
					<Leisure />
					<ScrollToTop  />
					<Contact />
				</>
			)}
		</>
	);
}

export default App;
